import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ConfigService, ConfigServiceConfig } from './config-service';

@NgModule({
    imports: [ HttpClientModule ]
})
export class ConfigModule {
    static forRoot(config: ConfigServiceConfig): ModuleWithProviders<ConfigModule> {
        return {
            ngModule: ConfigModule,
            providers: [
                ConfigService,
                {
                    provide:  ConfigServiceConfig,
                    useValue: config,
                }
            ]
        };
    }
}
